import { useMemo } from 'react';
import { useLogout } from '@sib/auth';
import { useTranslation } from '@sib/i18n';

interface MenuItem {
  label: string;
  action: () => void;
}

export const useMenuItems = () => {
  const { t } = useTranslation();
  const { mutate: logout } = useLogout();
  const menuItems: MenuItem[] = useMemo(
    () => [
      {
        label: t('components.userMenu.logout'),
        action: logout,
      },
    ],
    [t, logout]
  );

  return menuItems;
};
